import PropTypes, { element } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';
import _ from 'lodash';
import CrosstabViewer from '../../containers/CrosstabViewer';
import {
  CROSSTAB_CONSTANT,
  CROSSTAB_RUN_REPORT_SS,
  ADD_CROSSTAB_GRID_COLUMN,
  ADD_CROSSTAB_GRID_ROW,
  ADD_CROSSTAB_GRID_BASE,
  FLEX_STUDY_TAG,
  ACTION_TYPE_OLD_SMART_SEARCH_CLICKED,
  ACTION_TYPE_NEW_SMART_SEARCH_CLICKED,
  CROSSTAB_FEATUREID,
  AUTOCODE_ACCESS_ID,
} from '../../constants';
import { CROSSTAB_EDIT_EXPRESSION } from '../../trackerConstants';
import { HJ_CROSSTAB_EDIT_EXPRESSION } from '../../hotjarConstants';
import * as studyActions from '../../actions/studyActions';
import CommonStudySelector from '../common/CommonStudySelector';
import rowsIcon from '../../images/rows_icon_normal_state.png';
import columnsIcon from '../../images/columns_icon_normal_state.png';
import basesIcon from '../../images/bases-small-icon_blue.png';
import enlargeIcon from '../../images/enlarge-icon_48-67-93.png';
import runIcon from '../../images/run_report_icon_normal.png';
import enlargeHoverIcon from '../../images/enlarge-icon_brown.png';
import rowsHoverIcon from '../../images/rows-icon_brown.png';
import basesHoverIcon from '../../images/bases-small-icon.png';
import columnsHoverIcon from '../../images/columns-icon.png';
import runHoverIcon from '../../images/run_report_icon_hover.png';
import rowsDisabledIcon from '../../images/rows_icon_disabled.png';
import basesDisabledIcon from '../../images/bases_icon_disabled.png';
import columnsDisabledIcon from '../../images/columns_icon_disabled.png';
import runDisabledIcon from '../../images/run_report_icon_disabled.png';
import { GEOGRAPHY_BASES } from '../../actions/actionTypes';
import * as crosstabActions from '../../actions/crosstabActions';
import * as dictionaryActions from '../../actions/dictionaryActions';
import Modal from '../common/Modal/Modal';
import GenericButton from '../common/GenericButton';
import SmartSearch from '../common/SmartSearch/SmartSearch';
import { sendVPVHotjarEvent } from '../../util/hotjarUtils';
import { isAllFeaturePresent } from '../../util/CommonUtils';
import { buildAutoCodeObject } from '../../util/autocodeUtils';
import * as cnsts from '../autocode/AutocodeConstants';

import { getDicForDefKeywords } from '../../actions/autocodeActions';
import {
  checkKeywords,
  combineOperatorForExpressions,
  combineOperatorForObjectsAdded,
} from '../autocode/AutocodeFunctions';

const addAfterRunCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};
class SmartSearchEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isViewScreenSelected: false,
      studies: props.studies ? props.studies : [],
      defaultStudy: {},
      showWeightType: true,
      baseBtnDisabled: true,
      colBtnDisabled: true,
      rowBtnDisabled: true,
      runBtnDisabled: true,
      isTagInputExpanded: true,
      isRunEnabled: false,
      isBaseEnabled: false,
      isGeoDataPoint: false,
      baseTitle: 'Move to bases',
      expressionFormed: [],
      validExpression: true,
      editExpression: false,
    };
    this.smartSearchBox = React.createRef();
    this.crosstabViewer = React.createRef();
  }

  UNSAFE_componentWillMount() {
    if (this.props.crosstabTableList && this.props.crosstabTableList.length) {
      this.setState({ isViewScreenSelected: true });
    }
    if (this.props.allFeatures) {
      this.setState({
        isAutocodePresent: isAllFeaturePresent(
          AUTOCODE_ACCESS_ID,
          this.props.allFeatures
        ),
      });
    }
  }

  componentDidMount() {
    this.onMount();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.crosstabTableList !== nextProps.crosstabTableList) {
      this.setState({
        isViewScreenSelected:
          nextProps.crosstabTableList && nextProps.crosstabTableList.length > 0,
      });
    }
    if (nextProps.studies && nextProps.studies !== this.props.studies) {
      this.setState(() => ({ studies: nextProps.studies }));
    }
    if (
      nextProps.crosstabStudy &&
      nextProps.crosstabStudy !== this.props.crosstabStudy
    ) {
      this.setState(() => ({
        defaultStudy: nextProps.crosstabStudy,
      }));
    }
    // set a flag to inable or disable the base button base on geo base for flex market studies
    if (
      this.props.crosstabStudy &&
      this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (this.state.expressionFormed.length > 0) {
        const expression = this.state.expressionFormed.join(',');
        let baseCnt = 0;
        GEOGRAPHY_BASES.forEach(geoBase => {
          if (expression.includes(geoBase)) {
            baseCnt += 1;
          }
        });
        if (
          baseCnt > 0 &&
          nextProps.crosstabBases &&
          nextProps.crosstabBases.length === 0
        ) {
          this.setState(() => ({
            isBaseEnabled: true,
            baseTitle: 'Move to bases',
          }));
        } else if (
          nextProps.crosstabBases &&
          nextProps.crosstabBases.length > 0
        ) {
          this.setState(() => ({
            isBaseEnabled: false,
            baseTitle: 'Only one geographic base can be added',
          }));
        } else {
          this.setState(() => ({
            isBaseEnabled: false,
            baseTitle: 'Base must include a Geography',
          }));
        }
      } else if (
        nextProps.crosstabBases &&
        nextProps.crosstabBases.length > 0
      ) {
        this.setState(() => ({
          isBaseEnabled: false,
          baseTitle: 'Only one geographic base can be added',
        }));
      } else {
        this.setState(() => ({
          isBaseEnabled: false,
          baseTitle: 'Base must include a Geography',
        }));
      }
    }
    // set a flag to inable or disable the run button
    if (
      this.props.crosstabStudy &&
      !this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        (nextProps.crosstabRows && nextProps.crosstabRows.length > 0) ||
        (nextProps.crosstabCols && nextProps.crosstabCols.length > 0)
      ) {
        this.setState(() => ({ isRunEnabled: true }));
      } else {
        this.setState(() => ({ isRunEnabled: false }));
      }
    } else if (
      this.props.crosstabStudy &&
      this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
    ) {
      if (
        nextProps.crosstabBases &&
        nextProps.crosstabBases.length > 0 &&
        ((nextProps.crosstabRows && nextProps.crosstabRows.length > 0) ||
          (nextProps.crosstabCols && nextProps.crosstabCols.length > 0))
      ) {
        let geoBaseCnt = 0;
        nextProps.crosstabBases.forEach(crosstabBase => {
          GEOGRAPHY_BASES.forEach(geoBase => {
            if (crosstabBase.keyword.includes(geoBase)) {
              geoBaseCnt += 1;
            }
          });
        });
        if (
          geoBaseCnt > 0 &&
          nextProps.crosstabBases &&
          nextProps.crosstabBases.length === 1
        ) {
          this.setState(() => ({ isRunEnabled: true }));
          this.setState(() => ({ isBaseEnabled: false }));
        } else {
          this.setState(() => ({ isRunEnabled: false }));
        }
      } else {
        this.setState(() => ({ isRunEnabled: false }));
      }
    }
    /**
     * set a flag to hide and show sample weighted label on top of smart search
     */
    if (this.state.expressionFormed) {
      let geoDataCnt = 0;
      GEOGRAPHY_BASES.map(keyword => {
        this.state.expressionFormed.filter(exp => {
          if (exp && exp.includes(keyword)) {
            geoDataCnt += 1;
          }
          return exp;
        });
        return keyword;
      });
      if (geoDataCnt > 0) {
        this.setState(() => ({ isGeoDataPoint: true }));
      } else {
        this.setState(() => ({ isGeoDataPoint: false }));
      }
    }
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({
          baseBtnDisabled: false,
          colBtnDisabled: false,
          rowBtnDisabled: false,
        });
      } else {
        this.setState({
          baseBtnDisabled: true,
          colBtnDisabled: true,
          rowBtnDisabled: true,
        });
      }
    }
  }

  onMount = () => {
    if (this.props.crosstabStudy) {
      this.setState(() => ({
        defaultStudy: this.props.crosstabStudy,
      }));
    }
  };

  getCrosstabTitle = () =>
    this.crosstabViewer && this.crosstabViewer.current
      ? this.crosstabViewer.current.getCrosstabTitle()
      : 'untitled';

  setSelectedStudy = (selectedStudy, updatedWeightType) => {
    this.setState(() => ({ actualWeightType: selectedStudy.wt }));
    this.props.handleStudyChange(selectedStudy, updatedWeightType);
  };

  handleDataHaulGridResize = dimensions => {
    this.setState({
      dataHaulGridWidth: dimensions.width,
      dataHaulGridHeight: dimensions.height,
    });
  };

  toggleCrosstabView = isViewScreenSelected =>
    this.setState({ isViewScreenSelected });

  resetSmarchSearch = () => this.smartSearchBox.current.resetAll();

  handleCrosstabEdit = (idKey, dataSmartSearch) => {
    this.props.trackerFn({ action: CROSSTAB_EDIT_EXPRESSION });
    sendVPVHotjarEvent(HJ_CROSSTAB_EDIT_EXPRESSION);
    this.smartSearchBox.current.editCrosstabGrid(idKey, dataSmartSearch);

    this.setState({ editExpression: !this.state.editExpression });
  };

  handleChangeWeightType = weightType => {
    const updatedStudyItem = {
      ...this.state.defaultStudy,
      wt: weightType,
    };
    this.props.studyActions.updateModuleStudy('crosstab', updatedStudyItem);
  };

  handleToggleSearchEditor = () => {
    this.smartSearchBox.current.toggleSearchEditor();
  };

  /**
   * Method to handle mouse over
   */
  mouseOver = e => {
    const event = e;
    event.currentTarget.childNodes[0].childNodes[0].src =
      event.currentTarget.childNodes[0].childNodes[0].dataset.hoversrc;
  };

  /**
   * Method to handle mouse out
   */
  mouseOut = e => {
    const event = e;
    event.currentTarget.childNodes[0].childNodes[0].src =
      event.currentTarget.childNodes[0].childNodes[0].dataset.src;
  };

  resetAll = () => {
    this.setState({ expressionFormed: [], validExpression: true });
  };

  /**
   * Move Rows & columns to Cross tab ToolPallate
   */
  handleMove = targetGrid => {
    const {
      expressionFormed,
      objectsAdded,
      selectedCategoryID,
      tags,
    } = this.smartSearchBox.current.state;

    this.smartSearchBox.current.handleSelectedIndexState();
    const updatedExpressionFormed = combineOperatorForExpressions(
      expressionFormed
    );
    const updatedobjectsAdded = combineOperatorForObjectsAdded(objectsAdded);

    let objSmartSearchArray = [];
    if (this.state.isAutocodePresent) {
      const newExpressionFormed = updatedExpressionFormed
        .map(exp => _.toString(exp))
        .filter(item => checkKeywords(item));
      getDicForDefKeywords(
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.props.crosstabStudy.pn,
        newExpressionFormed
      )
        .then(response => {
          objSmartSearchArray = [
            {
              expressionFormed: updatedExpressionFormed,
              objectsAdded: updatedobjectsAdded,
              selectedCategoryID,
              tags,
              autocodenode: buildAutoCodeObject(
                updatedExpressionFormed,
                updatedobjectsAdded,
                response
              ),
            },
          ];
          this.handleCRBMove(targetGrid, objSmartSearchArray);
        })
        .catch(e => {
          objSmartSearchArray = [
            {
              expressionFormed: updatedExpressionFormed,
              objectsAdded: updatedobjectsAdded,
              selectedCategoryID,
              tags,
              autocodenode: buildAutoCodeObject(
                updatedExpressionFormed,
                updatedobjectsAdded
              ),
            },
          ];

          this.handleCRBMove(targetGrid, objSmartSearchArray);
        });
    } else {
      objSmartSearchArray = [
        {
          expressionFormed: updatedExpressionFormed,
          objectsAdded: updatedobjectsAdded,
          selectedCategoryID,
          tags,
        },
      ];
      this.handleCRBMove(targetGrid, objSmartSearchArray);
    }
  };

  handleCRBMove = (targetGrid, objSmartSearchArray) => {
    const {
      expressionFormed,
      objectsAdded,
      selectedCategoryID,
      tags,
    } = this.smartSearchBox.current.state;

    this.smartSearchBox.current.handleSelectedIndexState();
    const {
      crosstabStudy,
      loginResponse,
      activeAccountId,
      gridData,
      sampleWeightedKPIs,
      crosstabTableList,
    } = this.props;

    const expression = expressionFormed.join(' ');
    if (crosstabStudy && expressionFormed.length > 0) {
      const selectedNames = [
        objectsAdded.reduce((acc, { shortText }) => `${acc} ${shortText}`, ''),
      ];
      const geographyBase = GEOGRAPHY_BASES.some(base =>
        expression.includes(base)
      );
      let recTypes = [];
      if (geographyBase) {
        recTypes.push('G');
      } else {
        recTypes = [
          objectsAdded.reduce((acc, { recType }) => `${recType}`, ''),
        ];
      }
      const sampleWeightedParams = {
        token: loginResponse.data.token,
        uid: loginResponse.data.uid,
        accountId: activeAccountId,
        productNo: crosstabStudy.pn,
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        gridData:
          gridData[targetGrid] &&
          targetGrid !== 'TargetDataGrid' &&
          targetGrid !== 'BaseDataGrid'
            ? gridData[targetGrid]
            : [],
        expressionList: [expressionFormed.join(' ')],
        originalNames: selectedNames,
        selectedNames,
        targetGrid,
        recTypes,
        objSmartSearchArray,
      };
      if (sampleWeightedKPIs[expression] === undefined) {
        this.props.getSampleWeighted(sampleWeightedParams);
      } else {
        let action = '';
        const responseData = [];
        switch (targetGrid) {
          case 'ColumnsDataGrid':
            action = ADD_CROSSTAB_GRID_COLUMN;
            break;
          case 'RowsDataGrid':
            action = ADD_CROSSTAB_GRID_ROW;
            break;
          case 'BasesDataGrid':
            action = ADD_CROSSTAB_GRID_BASE;
            break;
          default:
            action = '';
            break;
        }
        if (action !== '') {
          this.props.trackerFn({
            action,
            attributes: { expression: selectedNames },
          });
        }
        if (
          this.props.crosstabStudy &&
          this.props.crosstabStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)
        ) {
          responseData.push(sampleWeightedKPIs[expression].data[0]);
          sampleWeightedParams.response = responseData;
        } else {
          sampleWeightedParams.response = sampleWeightedKPIs[expression].data;
        }
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }

      // if data point is getting added after running the report prompt user to run again
      if (
        crosstabTableList &&
        crosstabTableList.length &&
        !this.props.dataPointsAlreadyAdded
      ) {
        this.addAfterRunCrosstabModal.show();
      }
      if (
        crosstabTableList &&
        crosstabTableList.length &&
        !this.props.dataPointsAlreadyAdded
      ) {
        this.props.dictionaryActions.setDataPointAlreadyAdded(true);
      }
      this.smartSearchBox.current.resetAll();
      this.setState({ expressionFormed: [], validExpression: true });
    }
  };

  getLatestExpression = (expressions, validExpression) => {
    this.setState(() => ({
      expressionFormed: expressions,
      validExpression,
    }));
  };

  getSampleWeightedOfExistingKPIs = weightList => {
    const {
      loginResponse,
      activeAccountId,
      crosstabStudy,
      crosstab,
    } = this.props;
    let sampleWeightedParams = {
      token: loginResponse.data.token,
      uid: loginResponse.data.uid,
      accountId: activeAccountId,
      productNo: crosstabStudy.pn,
      weightType: weightList.wt,
      divisor: weightList.dv || 1000,
      weightChange: true,
    };

    if (crosstab.BasesDataGridData && crosstab.BasesDataGridData.length > 0) {
      const userStateData = this.generateGridData(
        crosstab,
        'BasesDataGridData'
      );
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BasesDataGrid',
        targetGrid: 'BasesDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    }

    if (
      crosstab.ColumnsDataGridData &&
      crosstab.ColumnsDataGridData.length > 0
    ) {
      const userStateData = this.generateGridData(
        crosstab,
        'ColumnsDataGridData'
      );
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
        isLabelUpdated: userStateData.isLabelUpdated,
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    }

    if (crosstab.RowsDataGridData && crosstab.RowsDataGridData.length > 0) {
      const userStateData = this.generateGridData(crosstab, 'RowsDataGridData');
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'RowsDataGrid',
        targetGrid: 'RowsDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
        isLabelUpdated: userStateData.isLabelUpdated,
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    }
  };

  generateGridData = (gridData, gridItem) => {
    const data = {
      selectedKeywords: [],
      selectedNames: [],
      originalNames: [],
      recTypes: [],
      dataSmartSearch: [],
      isLabelUpdated: [],
    };
    gridData[gridItem].forEach(item => {
      data.selectedKeywords.push(item.keyword);
      data.selectedNames.push(item.title);
      data.originalNames.push(item.originalTitle);
      data.recTypes.push(item.recType || item.rectype || item.type);
      data.dataSmartSearch.push(item.dataSmartSearch);
      data.isLabelUpdated.push(item.isLabelUpdated);
    });
    return data;
  };

  render() {
    return (
      <div>
        <div>
          <div className="smart-search-editor">
            <div className="appBreadcrumb">
              <div className="crosstab-study-selector">
                <CommonStudySelector
                  studies={this.state.studies}
                  featureID={CROSSTAB_FEATUREID}
                  defaultStudy={this.state.defaultStudy}
                  dataOnScreen={this.checkSCTabHasData}
                  alertMsg="This selection will impact all of the Crosstab modules"
                  setMethod={this.setSelectedStudy}
                  resetMethod={click => (this.resetSelectedSCStudy = click)}
                  showWeightType={this.state.showWeightType}
                  handleChangeWeightType={this.handleChangeWeightType}
                  hideWeightType={this.props.hideWeightType}
                  menuName={CROSSTAB_CONSTANT}
                  selectedWeightType={this.props.crosstabWeightTypes}
                  getSampleWeightedOfExistingKPIs={
                    this.getSampleWeightedOfExistingKPIs
                  }
                  disableSelection={this.props.tableView !== 'Trend'}
                  runReport={this.props.runAfterWeightChange}
                />
              </div>
              <div className="essential-breadcrumb-button">
                {this.state.isAutocodePresent && (
                  <React.Fragment>
                    <h6>SEARCH</h6>
                    <div className="back-to-autocode-search">
                      <Link onClick={() => this.props.toggleAutocode(true)}>
                        Composer
                      </Link>
                    </div>
                  </React.Fragment>
                )}

                <div className="back-to-dictionary-search">
                  <Link onClick={this.handleToggleSearchEditor}>
                    Dictionary
                  </Link>
                </div>
              </div>
              <div className="essential-breadcrumb-label">
                <span className="parent">Essentials / </span>Crosstab
                <br />
              </div>
            </div>
            <SmartSearch
              toggleSearchEditor={this.props.toggleSearchEditor}
              selectedModule={CROSSTAB_CONSTANT}
              moduleStudy={this.props.crosstabStudy}
              getSampleWeighted={this.props.getSampleWeighted}
              removeKPI={this.props.crosstabActions.removeCrossTabKpiInfo}
              fetchKPI={this.props.fetchKPI}
              gridData={this.props.gridData}
              runCrosstab={this.props.runCrosstab}
              dataScreen={this.props.dataScreen}
              ref={this.smartSearchBox}
              viewerGridType={
                this.props.crosstabTableList &&
                this.props.crosstabTableList.length > 0 &&
                this.props.crosstabTableList[0].viewerGridType
              }
              trackerFn={this.props.trackerFn}
              isTagInputExpanded={this.state.isTagInputExpanded}
              resetAll={this.resetAll}
              getLatestExpression={this.getLatestExpression}
            />
            <div className="move-to-crosstab-wrapper">
              <div className="button-group">
                <a
                  className="button square-button"
                  onMouseOver={this.mouseOver}
                  onMouseOut={this.mouseOut}
                  onClick={() =>
                    this.setState({
                      isTagInputExpanded: !this.state.isTagInputExpanded,
                    })
                  }
                >
                  <div className="square">
                    {!this.state.isTagInputExpanded ? (
                      <img
                        src={enlargeIcon}
                        data-src={enlargeIcon}
                        data-hoversrc={enlargeHoverIcon}
                        alt="Expand Smart Search"
                        title="Expand Smart Search"
                      />
                    ) : (
                      <img
                        src={enlargeHoverIcon}
                        data-src={enlargeHoverIcon}
                        data-hoversrc={enlargeHoverIcon}
                        alt="Expand Smart Search"
                        title="Expand Smart Search"
                      />
                    )}
                    <span>EXPAND</span>
                  </div>
                </a>

                {!this.state.expressionFormed.length ||
                !this.state.validExpression ||
                (this.props.crosstabStudy.st
                  .toLowerCase()
                  .includes(FLEX_STUDY_TAG) &&
                  !this.state.isBaseEnabled) ? (
                  <a className="button square-button" disabled>
                    <div className="square">
                      <img
                        src={basesDisabledIcon}
                        data-src={basesDisabledIcon}
                        data-hoversrc={basesDisabledIcon}
                        alt="Move to Bases"
                        title={this.state.baseTitle}
                      />
                      <span>BASES</span>
                    </div>
                  </a>
                ) : (
                  <a
                    className="button square-button"
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onClick={() => this.handleMove('BasesDataGrid')}
                  >
                    <div className="square">
                      <img
                        src={basesIcon}
                        data-src={basesIcon}
                        data-hoversrc={basesHoverIcon}
                        alt="Move to Bases"
                        title="Move to bases"
                      />
                      <span>BASES</span>
                    </div>
                  </a>
                )}
                {!this.state.expressionFormed.length ||
                !this.state.validExpression ? (
                  <a className="button square-button" disabled>
                    <div className="square">
                      <img
                        src={columnsDisabledIcon}
                        data-src={columnsDisabledIcon}
                        data-hoversrc={columnsDisabledIcon}
                        alt="Move to Columns"
                        title="Move to columns"
                      />
                      <span className="move-to-column-label">COLUMN</span>
                    </div>
                  </a>
                ) : (
                  <a
                    className="button square-button"
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onClick={() => this.handleMove('ColumnsDataGrid')}
                  >
                    <div className="square">
                      <img
                        src={columnsIcon}
                        data-src={columnsIcon}
                        data-hoversrc={columnsHoverIcon}
                        alt="Move to Columns"
                        title="Move to columns"
                      />
                      <span className="move-to-column-label">COLUMN</span>
                    </div>
                  </a>
                )}
                {!this.state.expressionFormed.length ||
                !this.state.validExpression ? (
                  <a className="button square-button" disabled>
                    <div className="square">
                      <img
                        src={rowsDisabledIcon}
                        data-src={rowsDisabledIcon}
                        data-hoversrc={rowsDisabledIcon}
                        alt="Move to Rows"
                        title="Move to rows"
                      />
                      <span>ROWS</span>
                    </div>
                  </a>
                ) : (
                  <a
                    className="button square-button"
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onClick={() => this.handleMove('RowsDataGrid')}
                  >
                    <div className="square">
                      <img
                        src={rowsIcon}
                        data-src={rowsIcon}
                        data-hoversrc={rowsHoverIcon}
                        alt="Move to Rows"
                        title="Move to rows"
                      />
                      <span>ROWS</span>
                    </div>
                  </a>
                )}
                {this.state.isRunEnabled ? (
                  <a
                    className="button square-button"
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onClick={() => {
                      this.setState({ isTagInputExpanded: false });
                      this.props.runCrosstab();
                      this.props.trackerFn({ action: CROSSTAB_RUN_REPORT_SS });
                    }}
                  >
                    <div className="square">
                      <img
                        src={runIcon}
                        data-src={runIcon}
                        data-hoversrc={runHoverIcon}
                        alt="Run"
                        title={
                          this.props.crosstabStudy &&
                          this.props.crosstabStudy.st
                            .toLowerCase()
                            .includes(FLEX_STUDY_TAG) &&
                          this.props.crosstabBases.length === 0
                            ? 'Select a geography as base to continue'
                            : this.props.trendStudies &&
                              this.props.trendStudies.length > 1 &&
                              this.props.viewerGridType === 'Trend'
                            ? `Run Trend [${this.props.trendStudies.length} of studies]`
                            : 'Run'
                        }
                      />
                    </div>
                  </a>
                ) : (
                  <a className="button square-button" disabled>
                    <div className="square">
                      <img
                        src={runDisabledIcon}
                        data-src={runDisabledIcon}
                        data-hoversrc={runDisabledIcon}
                        alt="Run"
                        title={
                          this.props.crosstabStudy &&
                          this.props.crosstabStudy.st
                            .toLowerCase()
                            .includes(FLEX_STUDY_TAG)
                            ? 'Select a geography as base to continue'
                            : 'Run'
                        }
                      />
                    </div>
                  </a>
                )}
              </div>
            </div>
            {this.state.isViewScreenSelected && (
              <CrosstabViewer
                ref={this.crosstabViewer}
                isViewScreenSelected={this.state.isViewScreenSelected}
                handleCrosstabEdit={this.handleCrosstabEdit}
                cellElementList={this.props.cellElementList}
                resetSmarchSearch={this.resetSmarchSearch}
                stopSpinner={this.props.stopSpinner}
                selectedBase={this.props.selectedBase}
                handleSaveCrosstab={this.props.handleSaveCrosstab}
                trackerFn={this.props.trackerFn}
                editExpression={this.state.editExpression}
                handleProbabilitiesEditClick={
                  this.props.handleProbabilitiesEditClick
                }
              />
            )}
          </div>
        </div>
        <Modal
          title="Run Crosstab"
          ref={node => (this.addAfterRunCrosstabModal = node)}
          dialogStyles={addAfterRunCrosstabModalStyle}
        >
          <p>You have added a new data point. Please Run report again.</p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.addAfterRunCrosstabModal.hide()}
          />
        </Modal>
      </div>
    );
  }
}

SmartSearchEditor.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({}),
  }),
  activeAccountId: PropTypes.number,
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  cellElementList: PropTypes.arrayOf(PropTypes.object),
  toggleSearchEditor: PropTypes.func,
  crosstabStudy: PropTypes.shape({
    st: PropTypes.string,
  }),
  getSampleWeighted: PropTypes.func,
  fetchKPI: PropTypes.func,
  gridData: PropTypes.shape({}),
  runCrosstab: PropTypes.func,
  stopSpinner: PropTypes.func,
  dataScreen: PropTypes.string,
  study: PropTypes.shape({
    crosstabStudy: PropTypes.shape({}),
  }),
  trackerFn: PropTypes.func,
  handleStudyChange: PropTypes.func,
  dataPointsAlreadyAdded: PropTypes.bool,
  crosstabActions: PropTypes.shape({
    getSampleWeightedData: PropTypes.func,
    removeCrossTabKpiInfo: PropTypes.func,
    getSampleWeighted: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    setDataPointAlreadyAdded: PropTypes.func,
  }),
  sampleWeightedKPIs: PropTypes.shape({}),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  kpiInfo: PropTypes.shape({}),
  studies: PropTypes.arrayOf(PropTypes.object),
  hideWeightType: PropTypes.bool,
  trendStudies: PropTypes.arrayOf(PropTypes.object),
  viewerGridType: PropTypes.string,
  crosstabCols: PropTypes.arrayOf(PropTypes.object),
  crosstabRows: PropTypes.arrayOf(PropTypes.object),
  crosstabBases: PropTypes.arrayOf(PropTypes.object),
  newView: PropTypes.bool,
  crosstabWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  handleSaveCrosstab: PropTypes.func,
  handleProbabilitiesEditClick: PropTypes.func,
  allFeatures: PropTypes.arrayOf(PropTypes.array),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstabTableList: state.crosstab.crosstabTableList,
    crosstab: state.crosstab,
    study: state.study,
    studies: state.study.studies,
    crosstabStudy: state.study.crosstabStudy,
    dataPointsAlreadyAdded: state.dataPointsAlreadyAdded,
    sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
    kpiInfo: state.crosstab.kpiInfo,
    crosstabCols: state.crosstab.ColumnsDataGridData,
    crosstabRows: state.crosstab.RowsDataGridData,
    crosstabBases: state.crosstab.BasesDataGridData,
    trendStudies: state.study.trendStudies,
    newView: state.smartView,
    crosstabWeightTypes: state.study.crosstabWeightTypes,
    tableView: state.crosstab.activeCrosstabTable
      ? state.crosstab.activeCrosstabTable.viewerGridType
      : 'Private Eye',
    allFeatures: state.userDetail.allFeatures,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(SmartSearchEditor);
